import { config } from '@v4/config.js';
import { isUserAuthenticated } from '@v4/services/api/user.js';
import { eventService } from '@v4/services/event-service.js';
import { authenticationStatuses } from '@v4/login/config';

/**
 * It shows element when user is authenticated.
 *
 * @example
 * <div v-show-on-authenticated style="display:none;">Show me only if authenticated</div>
 */
export default {
    async inserted(el, binding) {
        const isAuthenticated = await isUserAuthenticated();
        const value = binding.value || 'inherit';
        if (isAuthenticated) {
            el.style.display = value;
        } else {
            el.style.display = 'none';
        }
        eventService.on(config.events.EVENT_GARAGE_AUTHENTICATION_STATUS_CHANGE, (data) => {
            if (data.status === authenticationStatuses.STATUS_AUTHENTICATED) {
                el.style.display = value;
            } else {
                el.style.display = 'none';
            }
        });
    },
};
